const PagesHeading = ({heading})=>{
    return <h1 className="h3 mx-3 my-1">{heading}</h1>
}

export default PagesHeading